export default __webpack_public_path__ + "3e76a04ca9345076bf10be769642cdb4.png";